import React from "react";
import Select from "react-select";

import { sortBy } from "../../../utils/commonFunctions";
import { formFilterDropdownPrimaryStyle } from "../../../utils/sharedDatasets";

const LocationFilter = ({
  selectedType,
  setFilterOption = () => {},
  programCounter = {},
  locationList = {}
}) => {
  const programLocations = locationList
    ?.map((loc) => ({
      title: loc
        .replace(/\b(\w)/g, (k) => k.toUpperCase())
        .replaceAll("-", " "),
      slug: loc,
      label: loc
    }))
    .sort(sortBy("title"));

  const customStyles = formFilterDropdownPrimaryStyle(
    {},
    {
      brand: process.env.GATSBY_DEFAULT_THEME
    }
  );

  const PlaceholderFC = ({ prefix, body }) => (
    <button className={`flex justify-between items-center grow`}>
      <div className="items-center text-left">
        {prefix && <p className="h8 opacity-60">{prefix}</p>}
        <h6 className="font-bold text-black-lighter">{body}</h6>
      </div>
    </button>
  );
  const formatOptionLabel = ({
    value,
    label,
    programCount,
    content,
    active
  }) => (
    <div className="flex items-center gap-x-4 whitespace-normal">
      <div
        className={`hidden sm:block mx-2 sm:mx-4 h-3 w-3 appearance-none text-white planet:text-gray-dark ring-1 ring-offset-4 bg-white ring-offset-current ring-gray-light planet:bg-gray-dark planet:ring-white rounded-full ${active ? "ring-red-light ring-offset-red-light ring-text-red-light  planet:bg-gray-dark planet:ring-offset-green-standard planet:ring-green-standard planet:text-green-standard" : " "} `}
      ></div>
      <div className="flex flex-col flex-1">
        <div className=" flex items-center gap-x-3">
          <div
            className="font-alice font-bold text-black-lighter planet:font-body planet:font-normal planet:text-white text-sm md:text-base xl:text-xl"
            dangerouslySetInnerHTML={{
              __html: [
                label.replace(/^(?!.*(journey|volunteer)).*$/i, "$&"),
                "&nbsp;",
                "(",
                programCount,
                ")"
              ].join("")
            }}
          />
        </div>
        <div
          className="font-body text-black-lighter planet:text-gray-generic text-xxxxs xl:text-xs hidden"
          dangerouslySetInnerHTML={{
            __html: content || label || ""
          }}
        />
      </div>
    </div>
  );
  return (
    <>
      <div className="block sm:hidden my-4">
        <Select
          formatOptionLabel={formatOptionLabel}
          options={programLocations
            ?.map((type) => ({
              value: type?.slug,
              label: type?.title,
              programCount: programCounter[type?.slug] || 0,
              content: type?.content,
              active:
                selectedType?.length > 0 && type?.slug?.includes(selectedType)
            }))
            ?.filter((item) => item?.programCount > 0)}
          className="z-20 h-full bg-white rounded-md location-selectbox planet:bg-gray-darkest planet:border planet:border-gray-testimonial/30"
          styles={customStyles}
          onChange={({ value }) => setFilterOption(value)}
          placeholder={<PlaceholderFC body={"Select a program location"} />}
        />
      </div>

      <div className="hidden sm:flex flex-col flex-1 h-full w-full border border-black-lighter planet:border-gray-nonary rounded-md gap-0 overflow-hidden bg-white planet:bg-gray-darkest">
        {programLocations?.map((programLocation, idx) => {
          const { title, slug, content } = programLocation || {};

          const active =
            selectedType?.length > 0 && slug?.includes(selectedType);
          const programCount = programCounter[slug] || 0;

          return (
            <div
              className={`block text-black hover:text-black-darken p-2 border-b border-gray-quindecimal planet:border-gray-nonary last-of-type:border-b-0 ${active ? "bg-gray-quindecimal planet:bg-gray-dark" : "bg-white planet:bg-gray-darkest"} `}
              key={idx}
              onClick={() => (programCount ? setFilterOption(slug) : {})}
            >
              <div
                className={`disabled-state-container ${programCount ? "cursor-pointer" : "opacity-20"}`}
              >
                {formatOptionLabel({
                  value: slug,
                  label: title,
                  programCount,
                  content,
                  active
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default LocationFilter;
